'use client';

import { c as _c } from "react/compiler-runtime";
import type { DateDrawsResultDate } from '@svs/nova-poolbetting/schema/date-picker';
import type { DrawNumber } from '@svs/nova-poolbetting/schema/draw';
import { format } from 'date-fns';
import { useRouter } from 'next/navigation';
import { type ReactNode } from 'react';
import { getSportInfoRouteFromDrawState } from '@/components/index.browser';
import { CouponResultDrawMenu } from './CouponResultDrawMenu';
type CouponResultDrawMenuContainerClientProps = {
  dateDraws: DateDrawsResultDate[];
  drawNumber: DrawNumber;
};

/**
 * Component for rendering a menu to select different draw numbers for a given date.
 *
 * @param param0 - The props object.
 * @param param0.dateDraws - The draws for the selected date, used to populate the menu with available draw numbers.
 * @param param0.drawNumber - The currently selected draw number, used to disable the corresponding button in the menu.
 * @returns A ReactNode representing the draw menu, or null if there is only one draw number.
 */
export function CouponResultDrawMenuContainerClient(t0) {
  const $ = _c(7);
  const {
    dateDraws,
    drawNumber
  } = t0;
  const router = useRouter();
  const basePath = process.env.NEXT_PUBLIC_BASE_PATH ?? "";
  let t1;
  if ($[0] !== dateDraws || $[1] !== router) {
    t1 = selectedDrawNumber => {
      const dateDraw_0 = dateDraws.find(dateDraw => dateDraw.drawNumber.toString() === selectedDrawNumber);
      if (!dateDraw_0) {
        return;
      }
      const drawState = dateDraw_0.drawState.client;
      const dateStr = format(dateDraw_0.date, "yyyy-MM-dd");
      const sportInfoRoute = getSportInfoRouteFromDrawState(drawState);
      router.push(`${basePath}/resultat/${dateStr}${sportInfoRoute}?draw=${selectedDrawNumber}&product=${dateDraw_0.product}`);
    };
    $[0] = dateDraws;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onChange = t1;
  let t2;
  if ($[3] !== dateDraws || $[4] !== drawNumber || $[5] !== onChange) {
    t2 = <CouponResultDrawMenu dateDraws={dateDraws} drawNumber={drawNumber} onChange={onChange} />;
    $[3] = dateDraws;
    $[4] = drawNumber;
    $[5] = onChange;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}